/**
 * Random variables used in the app
 */
export const WELCOME_ROUTE_PATH = 'welcome'
export const HELP_ROUTE_PATH = 'help'
export const SCAN_ROUTE_PATH = 'scan'
export const ACCESS_TOKEN_NAME = 'id-token'
